// Utility for AWS S3 URLs used in AboutPage and other pages

export const BarmaSorigVideoAdvertisement =
  "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/barma-sorig-ads.mp4";
export const videoThumbnail =
  "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/barma-sorig-ads-thumbnail.png";
export const founder =
  "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/barma-sorig-staff-members/Founder.jpg";
export const generalManager =
  "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/barma-sorig-staff-members/GeneralManager.jpeg";
export const generalSupervisor =
  "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/barma-sorig-staff-members/General+Supervisor.jpeg";
export const staff01 =
  "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/barma-sorig-staff-members/staff-SY.jpg";
export const staff02 =
  "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/barma-sorig-staff-members/staff-D.jpg";
